import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import { dayjs, useAppSelector, useAppDispatch, useLogout, DefaultRoutes } from "src/common";
import { Icon } from "..";
import { appActions } from "src/store";
import { RootState } from "src/store/configureStore";
import SettingsImage from "src/assets/images/device-lock.svg";

function DeviceLockedComponent() {
  const dispatch = useAppDispatch();
  const lock_info = useAppSelector((state: RootState) => state.app.locked_devices);
  const current_account = useAppSelector((state: RootState) => state.account.current_account);
  const locked_or_deleted = !!lock_info?.deleted ? "deleted" : "locked";
  const org_name = !!current_account ? current_account.org_info?.org_name : null;
  // NOTE: CONVERTS UTC TO LOCAL:
  const formatted_locked_date = !!lock_info?.lock_time ? dayjs.utc(lock_info.lock_time).local().format("MMMM D, YYYY h:mm A") : null;
  const { handleStateLogout } = useLogout();

  useEffect(() => {
    handleStateLogout();

    return () => {
      dispatch(appActions.deviceLockedSet(undefined));
    };
  }, []);

  return <div className="mx-auto max-600 mt-4">
    <h1 className="main-header">This Device is {locked_or_deleted}
      {
        !!lock_info?.display_name &&
        <>
          &nbsp; for <b>{lock_info.display_name}</b>
        </>
      }
    </h1>
    <Card className="pv-card mb-2">
      <Card.Img variant="top" src={SettingsImage} />
      <Card.Body>
        <p className="semi-bold fs-3">For your security, you can't access your PreVeil account from this computer.</p>
        {
          !!lock_info &&
          <p>
            This device was {locked_or_deleted} by <b>{lock_info.lock_by_user_name}</b>&nbsp;
            {
              !!lock_info.lock_by_user_id &&
              <b>[{lock_info.lock_by_user_id}]&nbsp;</b>
            }
            {
              !!formatted_locked_date &&
              <>
                on <b>{formatted_locked_date}</b>&nbsp;
              </>
            }
            {
              !!lock_info.lock_using_device &&
              <>from <b>{lock_info.lock_using_device}</b></>
            }
          </p>
        }
        <p>This device will remain locked until unlocked from one of your other devices.
          {
            !!org_name && <>
              or an administrator for <b>{org_name}</b>
            </>
          }
        </p>
      </Card.Body>
    </Card>
    <p><Icon className="pv-icon-question" /><span>Learn more about locked devices <a target="_blank" rel="noreferrer" href={`${DefaultRoutes.remote_webapp_url}/support`}>preveil.com/support</a></span></p>
  </div>;
}

export default React.memo(DeviceLockedComponent);
